import { render, staticRenderFns } from "./ProfileInformationCard.html?vue&type=template&id=077f1b47&scoped=true&external"
import script from "./ProfileInformationCard.vue?vue&type=script&lang=js"
export * from "./ProfileInformationCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileInformationCard.scss?vue&type=style&index=0&id=077f1b47&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f1b47",
  null
  
)

export default component.exports